import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';
import NavLanguage from '../AppNav/NavLanguage';
import './style.scss';

const PublicAuthHeader = ({ onBack, title, subtitle }, context) => (
  <div className="public-auth-header">
    <div className="public-auth-header__bar">
      {onBack ? (
        <Button type="link" className="btn-back public-auth-header__back" onClick={onBack}>
          <Icon type="arrow-left" /> {context.t('Back')}
        </Button>
      ) : (
        <span />
      )}
      <NavLanguage variant="public" />
    </div>
    {title && <h1 className="header-title public-auth-header__title">{title}</h1>}
    {subtitle && <p className="public-auth-header__subtitle">{subtitle}</p>}
  </div>
);

PublicAuthHeader.propTypes = {
  onBack: PropTypes.func,
  title: PropTypes.node,
  subtitle: PropTypes.node,
};

PublicAuthHeader.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default PublicAuthHeader;
